import logoAsset from "@/assets/salonturbo-logo.png.asset.json";
import { cn } from "@/lib/utils";

type WordmarkProps = {
  /** Größe von Logo + Schriftzug. */
  size?: "sm" | "md" | "lg";
  /** Nur das Logo (z. B. eingeklappte Sidebar). */
  logoOnly?: boolean;
  className?: string;
  /** Wortmarke auf dunklem Grund heller setzen. */
  inverted?: boolean;
};

const sizes = {
  sm: { img: "size-8", text: "text-[0.8rem]" },
  md: { img: "size-9 sm:size-10", text: "text-sm sm:text-[0.95rem]" },
  lg: { img: "size-12", text: "text-base" },
} as const;

export function Wordmark({
  size = "md",
  logoOnly = false,
  className,
  inverted = false,
}: WordmarkProps) {
  const s = sizes[size];

  return (
    <span className={cn("flex min-w-0 items-center gap-2.5", className)}>
      <img
        src={logoAsset.url}
        alt="SalonTurbo Logo"
        width={48}
        height={48}
        className={cn("shrink-0 object-contain", s.img)}
      />
      {!logoOnly && (
        <span
          className={cn(
            "wordmark truncate pt-0.5",
            s.text,
            inverted ? "text-espresso-foreground" : "text-foreground",
          )}
        >
          Salonturbo
        </span>
      )}
    </span>
  );
}
